import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, TextField } from "@mui/material";
import { Form, Input, Button, message, Select } from "antd";
import { useNavigate, useParams } from "react-router-dom";

import Dragger from "antd/es/upload/Dragger";
import { UploadOutlined } from "@ant-design/icons";
import useSelection from "antd/es/table/hooks/useSelection";


import SearchIcon from "@mui/icons-material/Search";
import Sidebars from "../../Components/Sidebar/sidebar";
import '../../css/vehicles.css';
import SearchBar from "../../Components/SearchBar";
import { BorderBottom } from "@mui/icons-material";
import appColors from "../../config/appColors";
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import VehicleView from "../../Components/VehicleView";
import { selectStyle } from "../../css/styles";
const { Option } = Select;


const NewUser = () => {


    const ids = useParams();

    console.log('ids', ids)
    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Adjust breakpoint as needed
    const user = useSelector((state) => state.authReducer.user);
    const [form] = Form.useForm();

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [phone, setPhone] = useState('');
    const [alternatePhone, setAlternatePhone] = useState('');
    const [dob, setDOB] = useState('');





    const onFinish = async () => {

        const body = {
            token: user?.token,
            name: name,
            email,
            password,
            phone, 
            alternate_phone: alternatePhone,
            dob:dob
        }
        const onSuccess = (res) => {
            console.log('res', res.data)
            message.success('Invoice added successfully');
            navigate('/users');
        }
        const onError = (err) => {
            console.log('err', err)
            message.error(err?.data?.error);
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.signup, onSuccess, onError);



    }


    return (
        <>
            <ThemeProvider theme={theme}>
                <div style={{ display: 'flex', }}>
                    <Sidebars />

                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 20, width: "75%" }} >
                        <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
                            Add New User
                        </span>
                        <Form
                            style={{ width: "100%", }}
                            layout="vertical"
                            form={form}
                        >
                            <div style={{ display: 'flex', flexDirection: 'column', width: "100%", borderRadius: 10, backgroundColor: appColors.white, marginTop: 10, paddingBottom: 10 }}>
                                <div style={{ width: "100%", height: 45, borderTopRightRadius: 10, borderTopLeftRadius: 10, backgroundColor: appColors.primary }}>
                                    <Typography style={{ color: appColors.white, fontSize: 16, fontWeight: 600, marginLeft: 10, marginTop: 10 }}>User Information</Typography>
                                </div>
                                <div style={{
                                    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: "98.5%",
                                    justifyContent: 'space-between', alignSelf: 'center', marginTop: 10,
                                }} >
                                    <Form.Item
                                        style={selectStyle}
                                        name="clientName"
                                    >
                                        <Typography style={labelStyle}>Name</Typography>
                                        <Input
                                            onChange={(v)=>setName(v.target.value)}
                                            className="textInput"
                                            value={name}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="clientEmail"
                                    >
                                        <Typography style={labelStyle}>Email</Typography>
                                        <Input
                                            onChange={(v)=>setEmail(v.target.value)}
                                            className="textInput"
                                            value={email}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="clientPhone"
                                    >
                                        <Typography style={labelStyle}>Password</Typography>
                                        <Input
                                            onChange={(v)=>setPassword(v.target.value)}
                                            className="textInput"
                                            value={password}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="clientLicense"
                                    >
                                        <Typography style={labelStyle}>Phone number</Typography>
                                        <Input
                                            onChange={(v)=>setPhone(v.target.value)}
                                            className="textInput"
                                            value={phone}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="clientLicense"
                                    >
                                        <Typography style={labelStyle}>Alternate number</Typography>
                                        <Input
                                            onChange={(v)=>setAlternatePhone(v.target.value)}
                                            className="textInput"
                                            value={alternatePhone}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="clientLicense"
                                    >
                                        <Typography style={labelStyle}>DOB</Typography>
                                        <Input
                                            onChange={(v)=>setDOB(v.target.value)}
                                            className="textInput"
                                            type='date'
                                            value={dob}
                                        />
                                    </Form.Item>
                                    <div style={{width:540}}/>
                                    
                                </div>
                            </div>


                            <Form.Item
                                style={{ textAlign: 'center', }}
                            >
                                <Button
                                    onClick={() => onFinish()}
                                    style={{
                                        height: 40, backgroundColor: appColors.primary, marginTop: 20,
                                        fontFamily: 'Poppins', fontSize: 14, fontWeight: 600, width: 200
                                    }}
                                    type="primary"
                                    htmlType="submit">

                                    Save
                                </Button>
                            </Form.Item>



                        </Form>
                    </div>

                </div>
            </ThemeProvider>
        </>
    )

}



const labelStyle = { color: appColors.black, fontSize: 14, fontFamily: 'Poppins', marginTop: 0 }

export default NewUser
